import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            // appName: "UniHealth",
            // appTagLineA: "Powering Healthcare for a Nation",
            // appTagLineB: "Efficiency, Access, and Better Outcomes",
            // appTagLineDesc: "Welcome to UniHealth ERP—the backbone of a seamless national healthcare system. Our platform ensures secure, compliant, and efficient healthcare management, empowering providers, insurers, and policymakers to deliver quality care at scale. With enterprise-grade security, automated compliance, and seamless interoperability, we make healthcare accessible, transparent, and future-ready. Log in to streamline operations and improve patient outcomes nationwide.",
            // appFootnote: "Welcome to UniHealth ERP—the backbone of a seamless national healthcare system. Our platform ensures secure, compliant, and efficient healthcare management, empowering providers, insurers, and policymakers to deliver quality care at scale. With enterprise-grade security, automated compliance, and seamless interoperability, we make healthcare accessible, transparent, and future-ready. Log in to streamline operations and improve patient outcomes nationwide.",

            appName: "bima.",
            appNameShort: "B.E",
            appTagLineA: "Streamlining Insurance",
            appTagLineB: "From end to end!",
            appTagLineDesc: "A powerful solution designed to optimize insurance operations, from underwriting to claims management. Enhance efficiency, reduce risk, and deliver seamless customer experiences with our all-in-one platform.",
            unifiedSystem: "Unified",
            seamlessOperations: "Seamless",
            trustedOutcomes: "Trusted",

            welcomeMessage: "Hallo {{param1}}, Welcome to {{param2}}!",
            login: "Log In",
            username: "Username",
            password: "Password",
            forgotPassword: "Forgot Password?",
            selectLanguage: "Language",
            reports: "Reports",
            report: "Report",
            preview: "Preview",
            home: "Home",
            claims: "Claims",
            claim: "Claim",
            payment: "Payment",
            payments: "Payments",
            receipt: "Receipt",
            receipts: "Receipts",
            everything: "Everything",
            entities: "Entities",
            policies: "Policies",
            vehicles: "Vehicles",
            search: "Search",
            oneNation: "One Nation",
            oneFuture: "One Future",
            oneHealth: "One Health",
            patients: "Patients",
            patient: "Patient",
            refresh: "Refresh",
            newClaim: "New Claim",
            close: "Close",
            save: "Save",
            status: "Status",
            date: "Date",
            claimNo: "Claim No",
            additionalInformation: "Additional Information",
            selectedServices: "Selected Services",
            availableServices: "Available Services",
            requested: "Requested",
            approved: "Approved",
            attachments: "Attachments",
            attachment: "Attachment",
            priority: "Priority",
            yourRef: "Your Ref",
            remarks: "Remarks",
            logout: "Logout",
            roleName: "Administrator",
            core: "Core",
            parameters: "Parameters",
            gettingStarted: "Getting Started",
            company: "Company",
            controls: "Controls",
            packages: "Packages",
            users: "Users",
            profile: "Profile",
            locations: "Locations",
            files: "Files",
            file: "File",
            numberGen: "Number Generation",
            finance: "Finance",
            calendars: "Calendars",
            currencies: "Currencies",
            banks: "Banks",
            bankAccounts: "Bank Accounts",
            integration: "Integration",
            coa: "Chart of Accounts",
            statement: "Statement",
            balances: "Balances",
            category: "Category",
            underwriting: "Underwriting",
            classes: "Classes",
            products: "Products",
            templates: "Templates",
            riskNotes: "Risk Notes",
            renewals: "Renewals",
            register: "Register",
            mortality: "Mortality",
            medicalTests: "Medical Tests",
            defaultRates: "Default Rates",
            claimBox: "Claim Box",
            payables: "Payables",
            receivables: "Receivables",
            setup: "Setup",
            transactions: "Transactions",
            medicalRequests: "Medical Requests",
            box: "Box",
            poweringHealthcare: "Powering Healthcare for a Nation",
            accessEfficiency: "Efficiency, Access, and Better Outcomes.",
            clientsAndPartners: "Clients & Partners",
            clientsAndPartnersDesc: "Start building your client and business partners base and keep track of all their details in one place. Add your first client to get started.",
            symptomsDiagnosis: "Symptoms & Diagnosis",
            note: "Note",
            notes: "Notes",
            male: "Male",
            female: "Female",
            other: "Other",
            symptoms: "Symptoms",
            diagnosis: "Diagnosis",
            service: "Service",
            applied: "Applied",
            limit: "Limit",
            qty: "QTY",
            action: "Action",
            claimApproval: "You are approving a total of {{currency}} {{approvalAmount}} against application of {{appliedAmount}}. Do you want to proceed?",
            moveToPayment: "Move claim {{claimNo}} to payment?",
            visit: "Visit",
            outstanding: "Outstanding",
            os: "OS",
            payee: "Payee",
            details: "Details",
            correspondence: "Correspondence",
            comments: "Comments",
            source: "Source",
            narration: "Narration",
            contribution: "Contribution",
            contributions: "Contributions",
            unspecified: "Unspecified",
            year: "Year",
            period: "Period",
            mode: "Mode",
            documentNo: "Doc No",
            amount: "Amount",
            summary: "Summary",
            accountsReceivables: "Accounts Receivables",
            accountsReceivablesDesc: "Welcome to Accounts Receivables! Simplify collections and stay on top of your receivables!",
            newReceipt: "New Receipt",
            accountsPayables: "Accounts Payables",
            accountsPayablesDesc: "Welcome to Accounts Payables! Simplify your workflow and gain better control over your finances!",
            newPayment: "New Payment",
            help: "Help",
            howItWorks: "How It Works",
            how: "How",
            email: "Email",
            emailToClient: "Email to client",
            download: "Download",
            document: "Document",
            documents: "Documents",
            clientsAndPatners: "Clients & Partners",
            clientsAndPatnersDesc: "Start building your client and business partners base and keep track of all their details in one place. Add your first client to get started.",
            reset: "Reset",
            voidApproval: "Void Approval",
            progress: "Progress",
            riskNoteNo: "Risk Note No",
            policyNo: "Policy No",
            policy: "Policy",
            carrier: "Carrier",
            intermediary: "Intermediary",
            insured: "Insured",
            phone: "Phone",
            type: "Type",
            admin: "Admin",
            newProduct: "New Product",
            newPolicy: "New Policy",
            previewDocument: "Preview Document",
            beneficiaries: "Beneficiaries",
            viewReserves: "View Reserves",
            movement: "Movement",
            previousAmount: "Previous Amount",
            currentAmount: "Current Amount",
            doneBy: "Done By",
            when: "When",
            direction: "Direction",
            injuries: "Injuries",
            addInjuredPerson: "Add Injured Person",
            sumInsured: "Sum Insured",
            billedPremium: "Billed Premium",
            premium: "Premium",
            paidPremium: "Paid Premium",
            osPremium: "OS Premium",
            claimAmount: "Claim Amount",
            paid: "Paid",
            addReserve: "Add Reserve",
            description: "Description",
            addDefaults: "Add Defaults",
            pick: "Pick",
            conditionsAndClauses: "Conditions and Clauses",
            referenceNo: "Reference Number",
            reference: "Reference",
            text: "Text",
            product: "Product",
            transaction: "Transaction",
            issuingBranch: "Issuing Branch",
            underwriter: "Underwriter",
            riskAndCoverage: "Risk and Coverage",
            premiumInstallments: "Premium Installments",
            wordings: "Wordings",
            excessAndDeductibles: "Excess and Deductibles",
            value: "Value",
            valueType: "Value Type",
            riskNote: "Risk Note",
            bizUnit: "Biz Unit",
            policyOwner: "Policy Owner",
            policyInformation: "Policy Information",
            matchedRecords: "Matched Records",
            docAmount: "DOC Amount",
            benefits: "Benefits",
            add: "Add",
            claimDetails: "Claim Details",
            stage: "Stage",
            importantDates: "Important Dates",
            intimation: "Intimation",
            coverFrom: "Cover From",
            coverTo: "Cover To",
            lossDate: "Loss Date",
            insuredLife: "Insured Life",
            jointInsuredLife: "Joint Insured Life",
            riskItem: "Risk Item",
            catg: "Catg",
            dateOfBirth: "Date of birth",
            ageNextBirthday: "Age Next Birthday",
            smoke: 'Smoke',
            taxNumber: "Tax Number",
            code: "Code",
            name: "Name",
            basicInformation: "Basic Information",
            closeAccount: "Close Account",
            reactivate: "Reactivate",
            underReview: "Under Review",
            form: "Form",
            surname: "Surname",
            personalInformation: "Personal Information",
            otherNames: "Other Names",
            idNo: "ID Number",
            gender: "Gender",
            dob: "Date of Birth",
            disabledPerson: "Disabled Person",
            employment: "Employment",
            flag: "Flag",
            monthlyIncome: "Monthly Income",
            institution: "Institution",
            occupation: "Occupation",
            debit: "Debit",
            credit: "Credit",
            affiliations: "Affiliations",
            household: "Household",
            others: "Others",
            totalHouseholdIncome: "Total Household Income",
            accountManagers: "Account Managers",
            manager: "Manager",
            controlLedgers: "Control Ledgers",
            ledgers: "Ledgers",
            types: "Types",
            expectedPremium: "Expected Premium",
            endorsementInstructions: "Endorsement Instructions",
            endorsements: "Endorsements",
            applicableClasses: "Applicable Classes",
            conditions: "Conditions",
            deductiblesExcess: "Deductibles & Excess",
            printSection: "Print Section",
            commissionCode: "Commission Code",
            commCode: "Comm Code",
            taxCode: "Tax Code",
            enabled: "Enabled",
            onetime: "One-time",
            motor: "Motor",
            cashAndCarry: "Cash & Carry",
            ends: "Ends",
            periodType: "Period Type",
            taccount: "T-Account",
            mainLedger: "Main Ledger",
            mainLedgers: "Main Ledgers",
            subLedger: "Sub Ledger",
            subLedgers: "Sub Ledgers",
            cover: "Cover",
            covers: "Covers",
            charge: "Charge",
            charges: "Charges",
            subClass: "Sub Class",
            addLevel: "Add Level",

            // to translate from here
            addCover: "Add Cover",
            showQuantity: "Show Qty",
            motorProduct: "Motor",
            icon: "Icon",
            view: "View",
            attributes: "Attributes",
            applicableCovers: "Applicable Covers",
            applicableSmis: "Applicable SMIs",
            smi: "SMI",
            passangers: "Passangers",
            pax: "Pax",
            cc: "CC",
            yom: "YOM",
            color: "Color",
            use: "Use",
            engineNo: "Engine No",
            chassisNo: "Chassis No",
            regnNo: "Regn No",
            onDay: "On Day",
            endNo: "END No",
            from: "From",
            to: "To",
            years: "Years",
            premFreq: "Prem Freq",
            freq: "Freq",
            frequency: "Frequency",
            reinsurance: "Reinsurance",
            treaties: "Treaties",
            treaty: "Treaty",
            noOfLines: "# of Lines",
            siRange: "SI Range",
            treatyApplicable: "Treaty Applicable",
            particulars: "Particulars",
            deleteAll: "Delete All",
            selectAll: "Select All",
            unselectAll: "UnSelect All",
            tripDetails: "Trip Details",
            calculatePremium: "Calculate Premium",
            remove: "Remove",
            participants: "Participants",
            participant: "Participant",
            numberGeneration: "Number Generation",
            sequence: "Sequence",
            ok: "Ok",
            currentNo: "Current No",
            prefix: "Prefix",
            suffix: "Suffix",
            businessUnits: "Business Units",
            superAdmin: "Super Admin",
            administrators: "Administrators",
            reportVersions: "Report Versions",
            defaults: "Defaults",
            seekFac: "Seek FAC before approval if document is beyond capacity",
            riBatches: "RI Batches",
            riBatch: "RI Batch",
            batch: "Batch",
            batches: "Batches",
            newPlan: "New Plan",
            plan: "Plan",
            plans: "Plans",
            forecast: "Forecast",
            newForecast: "New Forecast",
            metrics: "Metrics",
            metric: "Metric",
            endorsementNo: "Endorsement No",
            endorsement: "Endorsement",
            glDate: "GL Date",
            reallocate: "Reallocate",
            lineType: "Line Type",
            line: "Line",
            addFac: "Add FAC",
            specialNotes: "Special Notes",
            underwriterRemarks: "Underwriter Remarks",
            noteNo: "Note No",
            newNote: "New Note",
            createAndManagePolicies: "Create & Manage Policies",
            createAndManagePoliciesDesc: "Easily create, manage, and share policies with our intuitive tools, ensuring accurate and detailed documentation for every policy. Empower your business with efficiency and precision in risk management.",
            createAndManageRiskNotes: "Create & Manage Risk Notes",
            createAndManageRiskNotesDesc: "Easily create, manage, and share risk notes with our intuitive tools, ensuring accurate and detailed documentation for every risk note. Empower your business with efficiency and precision in risk management.",
            firstPolicy: "First Policy",
            firstRiskNote: "First Risk Note",
            noteOwner: "Note Owner",
            owner: "Owner",
            fromDate: "From Date",
            toDate: "To Date",
            fullName: "Full Name",
            memberNo: "Member No",
            memberFrom: "Member From",
            memberTo: "Member To",
            certNo: "Cert No",
            shippingBy: "Shipping By",
            originAddress: "Origin Address",
            originPort: "Origin Port",
            estDepatureDate: "EST Depature Date",
            estArrivalDate: "EST Arrival Date",
            actDepatureDate: "ACT Depature Date",
            actArrivalDate: "ACT Arrival Date",
            destinationAddress: "Destination Address",
            destination: "Destination",
            destAddress: "Dest Address",
            dest: "Dest",
            origin: "Origin",
            destinationPort: "Destination Port",
            vesselNo: "Vessel No",
            destPort: "Dest Port",
            flightNo: "Flight No",
            marksNo: "Marks No",
            idfNo: "IDF No",
            firstClaim: "First Claim",
            via: "VIA",
            direct: "Direct",
            searchResults: "Search Results",
            proceed: "Proceed",
            bizDev: "Biz Dev",
            opportunities: "Opportunities",
            opportunity: "Opportunity",
            pipeline: "Pipeline",
            funnel: "Funnel",
            priorityLevel: "Priority Level",
            phoneNo: "Phone No",
            calculate: "Calculate",
            newOpportunity: "New Opportunity",
            test: "Test",
            team: "Team",
            winPerc: "Win %",
            method: "Method",
            methods: "Methods",
            deathBenefit: "Death Benefit",
            showBenefitMovement: "Show Benefit Movement",
            pleaseNote: "Please Note",
            additionalContacts: "Additional Contacts",
            revenueItems: "Revenue Items",
            activities: "activities",
            activity: "activity",
            addType: "Add Type",
            addCode: "Add Code",
            dueDate: "Due Date",
            due: "Due",
            totalRemitted: "Total Remitted",
            remitancesToCarrier: "Remitances To Carrier",
            osToCollect: "OS To Collect",
            osToRemit: "OS To Remit",
            addReceipt: "Add Receipt",
            outstandingPremium: "Outstanding Premium",
            totalPremium: "Total Premium",
            totalSumInsured: "Total Sum Insured",
            tenderInfo: "Tender Info",
            accountDetails: "Account Details",
            teamMember: "Team Member",
            teamMembers: "Team Members",
            premiumDue: "Premium Due",
            quoteRequest: "Quote Request",
            quoteRequests: "Quote Requests",
            quote: "Quote",
            quotes: "Quotes",
            new: "New",
            quoterequest: "Quote Request",
            contacts: "Contacts",
            contact: "Contact",
            cancel: "Cancel",
            isTender: "Is Tender",
            comm: "Comm",
            commission: "Commission",
            netDue: "Net Due",
            periodFrom: "Period From",
            periodTo: "Period To",
            billed: "Billed",
            issuer: "Issuer",
            country: "Country",
            dates: "Dates",
            eligibility: "Eligibility",
            evaluation: "Evaluation",
            award: "Award",
            awardedTo: "Awarded To",
            winner: "Winner",
            sendEmail: "Send Email",
            sendSms: "Send SMS",
            previewLetter: "Preview Letter",
            setPolicyNo: "Set Policy No",
            jobs: "Jobs",
            invoiceNo: "Invoice No",
            newEntity: "New Entity",
            addRate: "Add Rate",
            favourites: "Favourites",
            favourite: "Favourite",
            favouriteMenu: "Favourite Menu",
            favouriteMenus: "Favourite Menus",
            shortcuts: "Shortcuts",
            refreshed: "Refreshed",
            snapshot: "Snapshot",
            deals: "Deals",
            deal: "Deal",
            account: "Account",
            accounts: "Accounts",
            missionVision: "Mission & Vision",
            licenseNo: "License No",
            mission: "Mission",
            vision: "Vision",
            aboutUs: "About Us",
            changeAvatar: "Change Avatar",
            event: "Event",
            todo: "Todo",
            todoList: "Todo List",
            eventList: "Event List",
            eventsAndTodo: "Events & Todo",
            receiptNo: "Receipt No",
            paymentNo: "Payment No",
            received: "Received",
            allocated: "Allocated",
            receivedFrom: "Received From",
            payingFor: "Paying For",
            viewAll: "View All",
            addCategory: "Add Category",
            topN: "Top {{limit}}",
            topNby: "{{variable1}} by {{variable2}}",
            viewTopNby: "View top {{variable1}} by {{variable2}}",
            accountNo: "Account No",
            newCategory: "New Category",
            singleLoss: "Single Loss",
            singleTransit: "Single Transit",
            annualCarry: "Annual Carry",
            ladingNo: "Lading No",
            ladingDate: "Lading Date",
            transhipAt: "Tranship At",
            clearingAgent: "Clearing Agent",
            supplier: "Supplier",
            goodsDescription: "Goods Description",
            percentage: "Percentage",
            notSelected: "Not Selected",
            latitude: "Latitude",
            longitude: "Longitude",
            place: "Place",
            attribute: "Attribute",
            enterAddress: "Enter Address",
            contactAndAddress: "Contact & Address",
            physicalAddress: "Physical Address",
            postalAddress: "Postal Address",
            physical: "Physical",
            postal: "Postal",
            taxNo: "Tax No",
            relatedDocs: "Related Docs",
            timeline: "Timeline",
            amendments: "Amendments",
            netComm: "Net Comm",
            latestNoteNo: "Latest Note {{noteNo}}",
            latest: "Latest",
            addCharge: "Add Charge",
            basisOfClaim: "Basis of claim",
            basisOfClaimSettlement: "Basis of claim settlement",
            notSpecified: "Not Specified",
            enterBasisText: "Enter basis text",
            viewList: "View List",
            monthlyPremium: "Monthly Premium",
            applicablePerils: "Applicable Perils",
            perils: "Perils",
            peril: "Peril",
            showBeneficiaries: "Show Beneficiaries at risk level",
            showBasisOfClaim: "Show Basis Of Claim at risk level",
            showCharges: "Show Charges at risk level",
            showPerils: "Show Applicable Perils at risk level",
            showExcess: "Show Excess at risk level",
            allowAttachRisk: "Allow Attachment at risk level",
            showProjectInfo: "Show Project information",
            showParticulars: "Show Particulars",
            projectInformation: "Project information",
            projectPeriod: "Project Period",
            warrantyPeriod: "Warranty Period",
            maintenancePeriod: "Maintenance Period",
            limitsAndBenefits: "Limits & Benefits",
            benefit: "Benefit",
            schedule: "Schedule",
            addCondition: "Add Condition",
            addDeductible: "Add Deductible",
            saved: "Saved",
            savedParam: "{{param1}} saved",
            successSaved: "{{param1}} saved successfully",
            addedMsg: "{{param1}} added",
            added: "Added",
            success: "Success",
            error: "Error",
            benefitsAllowed: "Benefits Allowed",
            limitsAllowed: "Limits Allowed",
            showBenefits: "Show Benefits",
            showLimits: "Show Limits",
            limitsWontShow: "Please Note: Limits wont show in the document until (SHOW LIMITS ... the one above) is turned on",
            benefitsWontShow: "Please Note: Benefits wont show in the document until (SHOW BENEFITS ... the one above) is turned on",
            limitsOfLiability: "Limits of Liability",
            applicableBenefits: "Applicable Benefits",
            limitOf: "Limit Of",
            setDefault: "Set Default",
            noOfPkgs: "No of PKGS",
            noDataFound: "No data found",
            finish: "Finish",
            start: "Start",
            newUser: "New User",
            assignedRoles: "Assigned Roles",
            newTemplate: "New Template",
            template: "Template",
            activateWhatsApp: "Activate WhatsApp",
            whatsAppNo: "WhatsApp No",
            shareToWhatsApp: "Share To WhatsApp",
            whatsappDesc: "By Activating WhatsApp notifications, the client will receive notifications via the specified number. Ensure that this number is a VALID WhatsApp Number",
            characters: "Characters",
            character: "Character",
            caption: "Caption",
            assetMgt: "Assets",
            funds: "Funds",
            fund: "Fund",
            newFund: "New Fund",
            fundHomeTitle: "Fund Setup & Management",
            fundHomeDesc: "Define and manage your investment funds, including their structure, strategy, benchmarks, and key roles. Start by creating your first fund to begin allocating assets and onboarding investors.",
            managedFunds: "Managed Funds",
            benchmark: "Benchmark",
            benchmarks: "Benchmarks",
            benchmarkDesc: "Select the index or rate that represents the performance standard for this fund.",
            benchmarkTargetDesc: "Set the minimum return threshold (as a percentage) the fund must exceed in comparison to the selected benchmark. If the fund outperforms this target, performance-based fees will be triggered according to the fund’s fee structure.",
            securities: 'Securities',
            security: 'Security',
            subscriptions: "Subscriptions",
            subscription: "Subscription",
            navhistory: "NAV History",
            performance: "Performance",
            history: "History",
            operations: "Operations",
            analytics: "Analytics",
            changeImage: "Change Image",
            changeLogo: "Change Logo",
            selectImage: "Select Image",
            selectLogo: "Select Logo",
            initialNavPerUnit: "Initial NAV Per Unit",
            minNavSub: "Minimum Units to Subscribe",
            launchDate: "Launch Date",
            assetAllocation: "Asset Allocation",
            weightsInPerc: "Weights in %",
            totalWeightsPerc: "Total Weights {{perc}} %",
            assetClasses: "Asset Classes",
            assetClass: "Asset Class",
            addAssetClass: "Add Asset Class",
            fees: "Fees",
            addFee: "Add Fee",
            targetWeight: "Target Weight",
            minWeight: "Min Weight",
            maxWeight: "Max Weight",
            target: "Target",
            targetType: "Target Type",
            absolute: "Absolute",
            targetAbsoluteDesc: "Enter the fixed annual return target (e.g., 10%) that the fund must achieve before performance fees apply.",
            relative: "Relative",
            targetRelativeDesc: "Specify the minimum excess return (%) the fund must generate above the selected benchmark to trigger performance fees.",
            min: "Min",
            max: "Max",
            applicableOn: "Applicable On",
            applyOn: "Apply On",
            on: "On",
            rate: "Rate",
            ratePer: "Rate Per",
            trigger: "Trigger",
            fee: "Fee",
            rebalancingRule: "Rebalancing Rule",
            rebalancingRuleError: "Your rebalance method is {{method}} but you havent set the threshold",
            aumCap: "AUM Cap",
            expectedAum: "Expected AUM",
            eligibleInvestors: "Eligible Investors",
            investors: "Investors",
            investor: "Investor",
            eligible: "Eligible",
            riskProfile: "Risk Profile",
            investmentStrategy: "Investment Strategy",
            investment: "Investment",
            investments: "Investments",
            strategy: "Strategy",
            objective: "Objective",
            objectives: "Objectives",
            regions: "Regions",
            region: "Region",
            sectors: "Sectors",
            sector: 'Sector',
            subSectors: "Sub Sectors",
            subSector: "Sub Sector",
            horizon: "Horizon",
            currency: "Currency",
            newSecurity: "New Security",
            listing: "Listing",
            main: "Main",
            sub: "Sub",
            isin: "ISIN",
            isinNo: "ISIN #",
            agency: "Agency",
            rating: "Rating",
            ratings: "Ratings",
            data: "Data",
            ticker: "ticker",
            symbol: "Symbol",
            maturityDate: "Maturity Date",
            maturity: "Maturity",
            couponRate: "Coupon Rate",
            coupon: "Coupon",
            faceValue: "Face Value",
            tags: "Tags",
            tag: "Tag",
            amlScreened: "AML Screened",
            amlChecked: "AML Checked",
            amlCleared: "AML Cleared",
            identifiers: "Identifiers",
            license: "License",
            founded: "Founded",
            nameAndTitle: "Name & Title",
            title: "Title",
            keyPeople: "Key People",
            keyPerson: "Key Person",
            amlChecksDone: "AML Verification done",
            requiredDocuments: "Required Documents",
            required: "Required",
            partner: "Partner",
            layouts: "Layouts",
            applicableLayouts: "Applicable Layouts",
            grade: "Grade",
            issueDate: "Issue Date",
            issuedOn: "Issued On",
            face: "Face",
            depositTo: "Deposit To",
            ref: "Ref",
            deposit: "Deposit",
            receiptAmount: "Receipt Amount",
            paymentAmount: "Payment Amount",
            osToAllocate: "OS To Allocate",
            allocate: "Allocate",
            allocatedBase: "Allocated Base",
            allocation: "Allocation",
            allocationAmount: "Allocation Amount",
            allocationDate: "Allocation Date",
            allocationNo: "Allocation No",
            matchedBase: "Matched Base",
            allocationBalanceError: "For Receipts paying for {{param1}}, total allocated amount {{param2}} MUST equal the receipt amount {{param3}}",
            newSubscription: "New Subscription",
            subscriptionNo: "Subscription No",
            subscriptionDate: "Subscription Date",
            subscriptionAmount: "Subscription Amount",
            subscriptionStatus: "Subscription Status",
            subscriptionStatusDesc: "The status of the subscription, indicating whether it is pending, approved, or rejected.",
            subscriptionApproved: "Subscription Approved",
            subscriptionRejected: "Subscription Rejected",
            subscriptionPending: "Subscription Pending",
            subscriptionDetails: "Subscription Details",
            refNo: "Ref No",
            amountToDeposit: "Amount To Deposit",
            investing: "Investing",
            invest: "Invest",
            fixedAmount: "Fixed Amount",
            totalFees: "Total Fees",
            syncProfile: "Sync Profile",
            newProfile: "New Profile",
            requestTimedOut: "Request Timed Out",
            documentValidated: "{{param1}} successfully Validated",
            documentApproved: "{{param1}} successfully Approved",
            fundActivated: "Fund {{param1}} Activated",
            fundPaused: "Fund {{param1}} Paused",
            securityActivated: "Security {{param1}} Activated",
            securityPaused: "Security {{param1}} Paused",
            navAmount: "NAV Amount",
            unitsAllocated: "Units Allocated",
            units: "Units",
            monitor: "Monitor",
            newBenchmark: "New Benchmark",
            alias: "Alias",
            launch: "Launch",
            overview: "Overview",
            holdings: "Holdings",
            audit: "Audit",
            compliance: "Compliance",
            enrollInvestor: "Enroll Investor",
            enroll: "Enroll",
            enrollment: "Enrollment",
            ineligible: "Ineligible",
            transactionExists: "Transaction number {{param1}} already exists",
            delete: "Delete",
            atAGlance: "At a Glance",
            inceptionDate: "Inception Date",
            asOf: "As Of",
            asAt: "As At",
            class: "Class",
            totalFundDeposits: "Total Fund Deposits",
            totalAum: "Total AUM",
            netAssetValue: "Net Asset Value",
            accruedFees: "Accrued Fees",
            outstandingUnits: "Outstanding Units",
            unitsIssued: "Units Issued",
            topInvestors: "Top Investors",
            topNinvestors: "Top {{param1}} Investors",
            net: "Net",
            deposits: "Deposits",
            trades: "Trades",
            trade: "Trade",
            newTrade: "New Trade",
            no: "No",
            tradeDetails: "Trade Details",
            lastCoupon: "Last Coupon",
            settlement: "Settlement",
            settDt: "Sett DT",
            settlementDate: "Settlement Date",
            convention: "Convention",
            conv: "Conv",
            cleanPrice: "Clean Price",
            accruedInt: "Accrued Int",
            accruedInterest: "Accrued Interest",
            consideration: "Consideration",
            cons: "Cons",
            tenor: "Tenor",
            tenorInDays: "Tenor (Days)",
            couponsSchedule: "Coupons Schedule",
            transmit: "Transmit",
            documentTransmitted: "{{param1}} successfully transmitted to {{param2}}",
            settleTrade: "Settle Trade",
            review: "Review",
            tradeSettled: "Trade {{param1}} successfully settled",
            figuresAsOf: "Figures as of",
            availableCash: "Available Cash",
            netReturn: "Net Return",
            assets: "Assets",
            netAssets: "Net Assets",
            liabilities: "Liabilities",
            usedNav: "Used NAV",
            loggingIn: "Logging in...",
            compare: "Compare",
            compareRatesDesc: "Click here to compare carrier rates for {{param1}}",
            descriptionOfLoss: "Description Of Loss",
            registerNote: "Note: These value can be changed later",
            claimsHomeTitle: "Create & Manage Claims",
            claimsHomeDesc: "Effortlessly register, track, and manage claims across all lines of business. Keep both clients and carriers informed with automated email notifications, ensuring transparency and timely updates.",
            whichClaim: "Which claim do you want to open?",
            refineSearch: "Found {{param1}} results. Please refine your search",
            claimSearchPlaceholder: "Risk Note or Policy Number or Vehicle Registration",
            pleaseEnterSearch: "Please enter search criteria",
            enterDates: "Enter dates & description",
            selectCover: "Select Cover",
            model: "Model",
            relatedClaims: "Related Claims",
            getStatement: "Get Statement",
            entityStatement: "Entity Statement",
            openingBalance: "Opening Balance",
            totalDebits: "Total Debits",
            totalCredits: "Total Credits",
            noOfTrans: "No Of Trans",
            closingBalance: "Closing Balance",
            drcr: "DrCr",
            paidPrem: "Paid Prem",
            osPrem: "OS Prem",
            premiumRegister: "Premium Register",
            running: "Running",
            runningBalance: "Running Balance",
            tax: "Tax",
            found: "Found",
            totalCommission: "Total Commission",
            totalRefunds: "Total Refunds",
            multipleDocuments: "Receipt Multiple Documents",
            outstandingOnly: "Outstanding Only",
            successfullyCreated: "{{param1}} {{param2}} successfully created!",
            successfullyAdded: "{{param1}} {{param2}} successfully added!",
            successfullyUpdated: "{{param1}} {{param2}} successfully updated!",
            successfullyRemoved: "{{param1}} {{param2}} successfully removed!",
            bankAc: "Bank AC",
            bankAccount: "Bank Account",
            multipleReceiptsNote: "NB: You can only receipt risk notes that belong to the same client & currency",
            totalReceipts: "Total Receipts",
            receiptTotal: "Receipt Total",
            installment: "Installment",
            netCommission: "Net Commission",
            createReceiptPrompt: "Create receipt for {{param1}} totaling {{param2}} {{param3}}?",
            allFieldsMandatory: "All Fields are Mandatory",
            selectFile: "Select File",
            carValue: "Car Value",
            excessProtector: "Excess Protector",
            vehicleCheck: "Vehicle Check",
            commencementDate: "Commencement Date",
            expiryDate: "Expiry Date",
            import: "Import",
            downloadTemplate: "Download Template",
            taxExempt: "Tax Exempt",
            taxExemptDesc: "Tax Exempt Description",
            kycCheck: "Check KYC every specified days. Zero means no KYC check",
            kycFreq: "KYC Freq",
            reason: "Reason",
            cards: "Cards",
            card: "Card",
            cardNo: "Card No",
            list: "List",
            endpoint: "End Point",
            clientSince: "Client Since",
            allowFormatChange: "Allow format Change",
            format: "Format",
            allowBackgroundRun: "Allow Background Run",
            addReport: "Add Report",
            addKey: "Add Key",
            notifications: "Notifications",
            notification: "Notification",
            noNotifications: "No Notifications",
            read: "Read",
            unread: "Unread",
            documentNotFound: "Document not found",
            pathNotFound: "Path not found",
            dismiss: "Dismiss",
            reopenClaim: "Reopen Claim",
            closeClaim: "Close Claim",
            injuredPerson: "Injured Person",
            fatal: "Fatal",
            mortalityTable: "Mortality Table",
            medical: "Medical",
            renewable: "Renewable",
            jointType: "Joint Type",
            behavior: "Behavior",
            triggerClaim: "Trigger Claim",
            mainRider: "Main Rider",
            cashValue: "Cash Value",
            lapseDays: "Lapse Days",
            signatureSet: "Signature set for {{param1}} unit {{param2}} document",
            selectSignature: "Select Signature",
            updateSignature: "Update Signature",
            screenReports: "Screen Reports",
            updated: "Updated",
            deleted: "Deleted",
            creatingEntities: "Creating Entities",
            endApplCharges: "{{param1}} Endorsement Applicable Charges",
            oneVatText: "Ensure only ONE VAT is setup per endorsement type where applicable",
            totalComm: "Total Comm",
            bcc: "BCC",
            subject: "Subject",
            selectTemplate: "Select Template",
            taxExclusive: "Tax Exclusive",
            byPass: "By Pass",
            byPassChecks: "By Pass Checks",
            performChecks: "Perform Checks",
            continueWithUnderwriting: "Continue With Underwriting",
            ourComm: "Our Commission",
            videoWontDisplay: "This video wont display in your next login",
            changePassword: "Change Password",
            verifyNewPassword: " Verify New Password",
            newPassword: "New Password",
            currentPassword: "Current Password",
            verify: "Verify",
            passwordChanged: "Password successfully changed!",
            passwordChangedError: "Error changing password!",
            passwordChangedLogin: "Password successfully changed. Please log in!",
            resetPassword: "Reset Password",
            verifyPassword: "Verify Password",
            removedParam: "{{param1}} successfuly removed",
            deletedParam: "{{param1}} successfuly deleted",

            unableToRemove: "Unable to remove {{param1}}",
            unableToDelete: "Unable to delete {{param1}}",
            alreadyAdded: "{{param1}} already added",
            alreadyExists: "{{param1}} already exists",
            subClasses: "Sub Classes",
            financialInterest: "Financial Interest",
            financialInterestAppl: "Financial Interest Applicable?",
            issueParam: "Issue : {{param1}}",
            territory: "Territory",
            jurisdiction: "Jurisdiction",
            void: "Void",
            deleteRiskNote: "Do you want to delete this risk note?\nPlease NOTE this action is irrevasible",
            deviceCheck: "Check device on login",
            requestCode: "Request Code",
            confirmDeviceDesc: "You have Device/Browser check enabled and you havent logged in using this device/browser. We have generated an OTP and sent to your email. Please enter the OTP below",
            confirmDevice: "Confirm Device/Browser",
            update: "Update",
            addToSumInsured: "Add to Sum Insured",
            addToSi: "Add to SI",
            docsVerified: "KYC Documents Verified",
            linkMedical: "Link Medical",
            clickHere: "Click Here",
            changeInsured: "Change Insured",
            addInsured: "Add Insured",
            viewBeneficiaries: "View Beneficiaries",
            viewBenefits: "View Benefits",
            bondNo: "Bond No",
            purpose: "Purpose",
            bondDetails: "Bond Details",
            guarantor: "Guarantor",
            yrs: "Yrs",
            indemnitor: "Indemnitor",
            subAgent: "Sub Agent",
            emailTemplate: "Email Template",
            emailTemplates: "Email Templates",
            smsTemplate: "SMS Template",
            createAsClient: "Create as Client",
            createAsClientResult: "{{param1}} created as client!",
            maxDays: "Maximum No Of Days",
            revertValidation: "Revert Validation",
            activateKycChecks: "Activate KYC Checks",
            activateAmlChecks: "Activate AML Checks",
            setConfigurations: "Set Configurations",
            config: "Config",
            configuration: "Configuration",
            riskNotePrintSections: "Risk Note Print Sections",
            expressSmis: "Express SMIs",
            defaultSi: "Default SI",
            fclValue: "FCL Value",
            fclSi: "FCL & Default SI",
            smiName: "SMI Name",
            expressQuote: "Express Quote",
            expressNote: "Express Note",
            noVehicleFound: "No Vehicle Found with Registration {{param1}}",
            newClient: "New Client",
            setOrganizationConfig: "Set Organization Configurations",
            resetUserPassword: "Reset User Password",
            set: "Set",
            user: "User",
            passwordResetResult: "{{param1}} of {{param2}} password successfully reset!",
            healthInformation: "Health Information",
            mainCover: "Main Cover",
            newBusiness: "New Business",
            qualifications: "Qualifications",
            qualification: "Qualification",
            institutions: "Institutions",
            responsibilities: "Responsibilities",
            responsibility: "Responsibility",
            workExperience: "Work Experience",
            experience: "Experience",
            addQualification: "Add Qualification",
            addInstitution: "Add Institution",
            addResponsibility: "Add Responsibility",
            addExperience: "Add Experience",
            addJob: "Add Job",
            jobTitle: "Job Title",
            industry: "Industry",
            editJob: "Edit Job",
            jobCodeExists: "Job with code {{param1}} already exists",
            selectQualification: "Select Qualification",
            selectResponsibility: "Select Responsibility",
            qualRespExists: "{{param1}} {{param2}} already part of this job",
            newLeaveClass: "New Leave Class",
            annualHours: "Annual Hours",
            leaveClasses: "Leave Classes",
            leaveClass: "Leave Class",
            leaveTypes: "Leave Types",
            leaveEntitlement: "Leave Entitlement",
            entitlements: "Entitlements",
            carryOver: "Carry Over",
            carryOverHours: "Carry Over Hours",
            endorsed: "Endorsed",
            changeJointInsured: "Change Joint Insured",
            newPosition: "New Position",
            position: "Position",
            positions: "Positions",
            applicableLeaveTypes: "Applicable Leave Types",
            qualificationResponsibility: "Responsibilities & Qualifications",
            reportingTo: "Reporting To",
            notActivated: "Not Activated",
            hierachy: "Hierachy",
            positionCodeExists: "Position with code {{param1}} already exists",
            people: "People",
            peopleTitle: "People",
            peopleTitleDesc: "People registry for all employees, contractors, casuals and more...",
            newPerson: "New Person",
            moreDetails: "More Details",
            step: "Step",
            salaryStructure: "Salary Structure",
            leaveTypeExists: "Leave Type {{param1}} already part of this class",
            leaveType: "Leave Type",
            minSalary: "Min Salary",
            maxSalary: "Max Salary",
            onApproval: "On Approval",
            certPw: "Cert PW",
            clientId: "Client ID",
            portalUn: "Portal UN",
            portalPw: "Portal PW",
            dmvicApplicable: "DMVIC Applicable",
            dmvicCode: "DMVIC Code",
            issueCertificate: "Issue Certificate",
            vehicleMake: "Vehicle Make",
            vehicleModel: "Vehicle Model",
            bodyType: "Body Type",
            startDate: "Start Date",
            endDate: "End Date",
            vehicle: "Vehicle",
            selectVehicle: "Select Vehicle",
            addVehicle: "Add Vehicle",
            vehicleDetails: "Vehicle Details",
            certificateNote: "NOTE: The certificate will be sent to the email address below.",
            policySetCaution: "NOTE: Please ensure the entered policy number is CORRECT because once you set it, you cannot change",
            setPolicyNoFirst: "You MUST set Policy Number before issuing certificate. Do you want to set it now?",
            dmvicCodeMissing: "DMVIC code is not set for {{param1}} cover. Cannot issue certificate.",
            dmvicCoverMissing: "DMVIC cover type is not set for {{param1}} cover. Cannot issue certificate.",
            companyId: "Company ID",
            refreshToken: "Refresh Token",
            tokenRefreshed: "Token successfully refreshed",
            userInGroup: "{{param1}} is already part of {{param2}}",
            editGroup: "Edit Group",
            addGroup: "Add Group",
            mandatoryParam1: "{{param1}} is mandatory!",
            mandatoryParam2: "{{param1}} {{param2}} is mandatory!",
            taxPin: "Tax PIN",
            issuanceIdMissing: "Issuance Request ID is missing",
            certificateIssued: "Certificate {{param1}} successfully issued and sent to {{param2}}!",
            pleaseWait: "Please wait...",
            issuingDmvicCertificate: "Issuing DMVIC Certificate...",
            gettingDmvicCertificate: "Getting DMVIC Certificate {{param1}}...",
            confirmingDmvicCertificate: "Confirming DMVIC Certificate...",
            certificateType: "Certificate Type",
            vehicleType: "Vehicle Type",
            certificates: "Certificates",
            certificateDetails: "Certificate Details",
            certDetails: "Cert Details",
            previewCertificate: "Preview Certificate",
            cancelCertificate: "Cancel Certificate",
            cancellationReason: "Cancellation Reason",
            issuedBy: "Issued By",
            irreversibleAction: "NOTE: This action is irreversible",
            cancellingCertificateParam: "Cancelling certificate {{param1}}",
            certificateCancelled: "Certificate {{param1}} successfully CANCELLED!",
            unableToCancel: "Unable to cancel certificate {{param1}}. Please contact admin",
            certificateAlreadyCancelled: "Certificate {{param1}} is already cancelled",
            workedOnBy: "Worked On By",
            app: "App",
            application: "Application",
            otherAppsMapping: "Other Applications Mapping",
            whatsApp: "WhatsApp",
            generatingDmvicToken: "Generating DMVIC token...",
            tokenGenerated: "New token generated!",
            tokenGenerationFailed: "Token generation failed",
            certificateIssuanceFailed: "Certificate issuance failed!",
            calculatingPremium: "Calculating Premium...",
            fetchingDocument: "Fetching Document...",
            runningReport: "Running {{param1}} ...",
            renewalList: "Renewal List",
            sendRenewalInstructions: "Send Renewal Instructions",
            inviteForRenewal: "Invite For Renewal",
            renewalStatus: "Renewal Status",
            renewalStatusDesc: "NOTE: If you set renewal status to Do NOT Renew, you will not be able to process the document when renewal falls due.",
            renewalStatusResult: "Renewal Status set to {{param1}}",
            renewalStatusNotice: "Renewal Status is {{param1}}",
            newTerm: "New Term",
            addTerm: "Add Term",
            chqNo: "CHQ No",
            chqDate: "CHQ Date",
            externalUser: "External User",
            addCurrency: "Add Currency",
            addLedger: "Add Ledger",
            createNewPayment: "Create New Payment",
            createNewReceipt: "Create New Receipt",
            idNumber: "ID Number",
            addSubLedgers: "Add sub ledgers to {{param1}} [{{param2}}]",
            entitySubLedgers: "Sub ledgers for {{param1}} [{{param2}}] will be entity accounts",
            searchParam: "Search {{param1}}",
            contactSupport: "Contact Support",
            needHelp: "Need help?",
            closeChecklist: "Close Checklist",
            client: "Client",
            addSubClass: "Add Sub Class",
            addSmi: "Add SMI",
            glEntries: "GL Entries",
            glEntry: "GL Entry",
            newTicket: "New Ticket",
            ticket: "Ticket",
            tickets: "Tickets",
            allTickets: "All Tickets",
            inProgress: "In Progress",
            assignedTo: "Assigned to",
            raisedBy: "Raised by",
            slaStatus: "SLA Status",
            noTicketsFound: "No tickets found",
            showing: "Showing",
            open: "Open",
            resolved: "Resolved",
            activityAndCollab: "Activity & Collaboration",
            internal: "Internal",
            public: "Public",
            postComment: "Post Comment",
            detailedDesc: "Detailed Description",
            uploadedBy: "Uploaded By",
            browseFiles: "Browse Files",
            timeToResolve: "Time To Resolve",
            breached: "Breached",
            approachingBreach: "Approaching Breach",
            slaCategory: "SLA Category",
            targetToResolutionTime: "Target To Resolution Time",
            firstResponse: "First Response",
            resolution: "Resolution",
            activeWatchers: "Active Watchers",
            collaboration: "Collaboration",
            collaborator: "Collaborator",
            chat: "Chat",
            chats: "Chats",
            uploadFiles: "Upload Files",
            uploadFilesNo: "Upload {{param1}}",
            noFiles: "No files uploaded",
            addWatcher: "Add Watcher",
            noMembers: "No members found",
            createNewClaim: "Create New Claim",
            fullyPaid: "Fully Paid",
            partPaid: "Part Paid",
            notPaid: "Not Paid",
            claimStage: "Claim Stage",
            selectStage: "Select Stage",
            reserved: "Reserved",
            fullyAllocated: "Fully Allocated",
            confirmation: "Confirmation",
            currentReserve: "Current Reserve",
            allocateAmount: "Allocate Amount",
            allocateToClaim: "Allocate to Claim",
            lastUpdatedBy: "Last Updated By",
            edit: "Edit",
            pay: "Pay",
            suit: "Suit",
            ourRef: "Our Ref",
            analyze: "Analyze",
            viewAllReserves: "View All Reserves",
            reserveDetails: "Reserve Details",
            bids: "Bids",
            bid: "Bid",
            responses: "Responses",
            response: "Response",
            newBid: "New Bid",
            bidDetails: "Bid Details",
            selectBid: "Select Bid",
            all: "All",
            selectNone: "Select None",
            noBidsFound: "No bids found",
            bidAmount: "Bid Amount",
            bidResponse: "Bid Response",
            auctions: "Auctions",
            auction: "Auction",
            properties: "Properties",
            property: "Property",
            addProperty: "Add Property",
            reportedBy: "Reported By",
            reportedOn: "Reported On",
            reserve: "Reserve",
            principal: "Principal",
            created: "Created",
            timeToClose: "Time To Close",
            closed: "Closed",
            days: "Days",
            hours: "Hours",
            minutes: "Minutes",
            seconds: "Seconds",
            noAuctionsFound: "No auctions found",
            newAuction: "New Auction",
            auctionDetails: "Auction Details",
            noAttachments: "No attachments found",
            inviteStatus: "Invite Status",
            publish: "Publish",
            watcher: "Watcher",
            watchers: "Watchers",
            serviceType: "Service Type",
            scope: "Scope",
            address: "Address",
            function: "Function",
            relief: "Relief",
            matter: "Matter",
            caseRef: "Case Ref",
            batchNo: "Batch No",
            addTreaty: "Add Treaty",
            approveTreaty: "Approve Treaty",
            treatyApproved: "Treaty Approved",
            suspend: "Suspend",
            copyParam: "Copy {{param1}}",
            copy: "Copy",
            cqsPercentage: "CQS Percentage",
            qsPercentage: "QS Percentage",
            qsCqs: "QS/CQS",
            qsParticipants: "QS Participants",
            cqsParticipants: "CQS Participants",
            surplusParticipants: "Surplus Participants",
            currentApplicableCharges: "Current Applicable Charges",
            applyCharge: "Apply Charge",
            addNewCharge: "Add New Charge",
            treatySetupAllocError: "Current allocated {{param1}} percentage is {{param2}}. If you add {{param3}} {{param4}}, allocation, new total will be {{param5}}. This is not allowed. Total allocation cannot exceed 100%",
            setUnderReview: "Set Under Review",
            sharingTo: "Sharing to {{param1}}...",
            sharedWith: "Document shared with {{param1}}",
            share: "Share",
            message: "Message",
            scan: "Scan",
            process: "Process",
            processDocument: "Process Document",
            customerProfile: "Customer Profile",
            linkedPolicies: "Linked Policies",
            workflowData: "Workflow Data",
            agentControls: 'Agent Controls',
            takeOver: "Take Over",
            returnToBot: "Return to BOT",
            escalate: "Escalate",
            currentStep: "Current Step",
            paymentStatus: "Payment Status",
            makeModel: "Make/Model",
            weight: "Weight",
            height: "Height",
            editVehicleDetails: "Edit Vehicle Details",
            sessionStatus: "Session Status",
            beneficiary: "Beneficiary",
            applicationUsers: "Application Users",
            applicationUsersDesc: "Create application users and grant them roles and priviledges on what they can do in the system",
            defaultBranch: "Default Branch",
            addBranch: "Add Branch",
            editBranch: "Edit Branch",
            deleteBranch: "Delete Branch",
            addBank: "Add Bank",
            editBank: "Edit Bank",
            basis: "Basis",
            riskCharges: "Risk Charges",
            signToUse: "Signature To Use",
            userSignatures: "User Signatures",
            filterByProduct: "Filter By Product",
            gracePeriodDays: "Grace Period Days",
            importantInfo: "Important Info",
            importantInformation: "Important Information",
            commVatExcempt: "Commission is VAT Exempt",
            commWhExcempt: "Commission is WH Exempt",
            removed: "Removed",
            applicableCharges: "Applicable Charges",
            runReport: "Run Report",
            prev: "Prev",
            previous: "Previous",
            next: "Next",
            select: "Select",
            back: "Back",
            run: "Run",
            allowReceiptsIntoAc: "Allow Receipts into this account",
            allowPaymentsFromAc: "Allow Payments from this account",
            addEntity: "Add Entity",
            overrideChargeRate: "Add entities whose rate will be different from standard",
            overridentEntity: "Overriden rate for {{param1}}",
            applicableTerms: "Applicable Terms",
            reportGenBackground: "Report generation has started in the background. You will be notified when it's ready.",
            reportGenConvBackground: "Report generation was converted to run in the background because its taking longer to generate. You will be notified when it's ready.",
            editReport: "Edit Report",
            editParameter: "Edit Parameter",
            addParameter: "Add Parameter",
            updateParameter: "Update Parameter",
            hidden: "Hidden",
            readOnly: "Read Only",
            triggerRefresh: "Trigger Refresh",
            valueSet: "Value Set",
            parameter: "Parameter",
            addValueSet: "Add Value Set",
            dependencies: "Dependencies",
            staticValues: "Static Values",
            whereClause: "Where Clause",
            backgroundEmail: "If you run want to send emails, report will run in background then send the report on specified emails once job has finished",
            specifyEmailList: "Please specify email to receive the report. Separate emails with comma",
            riskExcess: "Risk Excess",
            excess: "Excess",
            excessDesc: "The amount that the insured must pay out of pocket before the insurance coverage kicks in.",
            eqZone: "EQ Zone",
            eqSubZone: "EQ Sub Zone",
            floodZone: "Flood Zone",
            floodSubZone: "Flood Sub Zone",
            journalsHome: "General Ledger",
            journalsHomeDesc: "Welcome to General Ledger! Simplify your accounting and stay on top of your financials!",
            createNewJournal: "Create New Journal",
            journalDetails: "Journal Details",
            noJournalsFound: "No journals found",
            journalNo: "Journal No",
            journals: "Journals",
            journalDate: "Journal Date",
            journalType: "Journal Type",
            dr: "Dr",
            cr: "Cr",
            documentReference: "Document Reference",
            documentRef: "Document Ref",
            lines: "Lines",
            newJournal: "New Journal",
            addLine: "Add Line",
            lineDetails: "Line Details",
            totalCredit: "Total Credit",
            totalDebit: "Total Debit",
            journalCreated: "Journal {{ param1}} successfully created!",
            typeToSearch: "Type Minimum {{param1}} Letter to Search",
            subType: "Sub Type",
            entity: "Entity",
            amountCannotBeZero: "Amount cannot be zero",
            amountMustBeZero: "Control amount must be zero",
            drcrFlag: "DrCr Flag",
            updateLine: "Update Line",
            deleteLine: "Delete Line",
            lineAdded: "Line successfully added to journal!",
            lineUpdated: "Line successfully updated!",
            lineDeleted: "Line successfully deleted!",
            updatingLine: "Updating line {{param1}}...",
            drcrError: "Difference between Debit {{param1}} and Credit {{param2}} amount is {{param3}}. The difference must be zero to proceed!",
            controlAmount: "Control Amount",
            voidReceipt: "Void Receipt",
            voidReceiptDesc: "Please note voiding receipt is irrevasible",
            voidReceiptResult: "Receipt Voided",
            voidPayment: "Void Payment",
            voidPaymentDesc: "Please note voiding payment is irrevasible",
            voidPaymentResult: "Payment Voided",
            filterByProductModule: "Filter by product or module",
            thisActionIsIrrevasible: "PLEASE NOTE: This action is irrevasible",
            documentVoided: "{{param1}} successfully voided",
            voidJournal: "Void Journal",
            voidJournalDesc: "Please note voiding journal is irrevasible",
            voidJournalResult: "Journal Voided",
            prorataPeriodDays: "Prorata Period Days",

        }
    },
    sw: {
        translation: {

            appName: "bima.",
            appNameShort: "B.E",
            appTagLineA: "Streamlining Insurance",
            appTagLineB: "From end to end!",
            appTagLineDesc: "A powerful solution designed to optimize insurance operations, from underwriting to claims management. Enhance efficiency, reduce risk, and deliver seamless customer experiences with our all-in-one platform.",

            welcomeMessage: "Habari {{param1}}, Karibu kwa {{param2}}!",
            login: "Ingia",
            username: "Jina la mtumiaji",
            password: "Nenosiri",
            forgotPassword: "Umesahau nenosiri?",
            selectLanguage: "Lugha",
            reports: "Ripoti",
            report: "Ripoti",
            preview: "Hakikisho",
            home: "Nyumbani",
            claims: "Madai",
            claim: "Dai",
            payment: "Malipo",
            payments: "Malipo",
            receipt: "Risiti",
            receipts: "Risiti",
            everything: "Kila kitu",
            entities: "Vyombo",
            policies: "Sera",
            vehicles: "Magari",
            search: "Tafuta",
            oneNation: "Taifa Moja",
            oneFuture: "Mustakabali Mmoja",
            oneHealth: "Afya Moja",
            patients: "Wagonjwa",
            patient: "Mgonjwa",
            refresh: "Sasisha",
            newClaim: "Dai Jipya",
            close: "Funga",
            save: "Hifadhi",
            status: "Hali",
            date: "Tarehe",
            claimNo: "Nambari ya dai",
            additionalInformation: "Maelezo ya ziada",
            selectedServices: "Huduma Zilizochaguliwa",
            availableServices: "Huduma Zinazopatikana",
            requested: "Ombwa",
            approved: "Imekubaliwa",
            attachments: "Viambatisho",
            attachment: "Kiambatisho",
            priority: "Kipaumbele",
            yourRef: "Marejeo Yako",
            remarks: "Maoni",
            logout: "Ondoka",
            roleName: "Msimamizi",
            core: "Msingi",
            parameters: "Vigezo",
            gettingStarted: "Anza",
            company: "Kampuni",
            controls: "Udhibiti",
            packages: "Vifurushi",
            users: "Watumiaji",
            profile: "Wasifu",
            locations: "Maeneo",
            files: "Faili",
            numberGen: "Uundaji wa Nambari",
            finance: "Fedha",
            calendars: "Kalenda",
            currencies: "Sarafu",
            banks: "Benki",
            bankAccounts: "Akaunti za Benki",
            integration: "Ujumuishaji",
            coa: "Mchoro wa Akaunti",
            statement: "Taarifa",
            balances: "Mizania",
            category: "Kategoria",
            underwriting: "Uhakiki wa Bima",
            classes: "Madarasa",
            products: "Bidhaa",
            templates: "Violezo",
            riskNotes: "Vidokezo vya Hatari",
            renewals: "Marekebisho",
            register: "Sajili",
            mortality: "Vifo",
            medicalTests: "Vipimo vya Matibabu",
            defaultRates: "Viwango vya Chaguo-msingi",
            claimBox: "Sanduku la Madai",
            payables: "Madai ya Kulipa",
            receivables: "Madai ya Kupokea",
            setup: "Usanidi",
            transactions: "Miamala",
            medicalRequests: "Maombi ya Matibabu",
            box: "Sanduku",
            poweringHealthcare: "Kuimarisha Huduma za Afya kwa Taifa",
            accessEfficiency: "Ufanisi, Upatikanaji, na Matokeo Bora.",
            clientsAndPartners: "Wateja & Washirika",
            clientsAndPartnersDesc: "Anza kujenga msingi wako wa wateja na washirika wa biashara na fuatilia maelezo yao yote mahali pamoja. Ongeza mteja wako wa kwanza ili kuanza.",
            symptomsDiagnosis: "Dalili & Uchunguzi",
            note: "Maelezo",
            notes: "Maelezo",
            male: "Mwanaume",
            female: "Mwanamke",
            other: "Nyingine",
            symptoms: "Dalili",
            diagnosis: "Uchunguzi",
            service: "Huduma",
            applied: "Imetumika",
            limit: "Kikomo",
            qty: "Kiasi",
            action: "Kitendo",
            claimApproval: "Unakubali jumla ya {{currency}} {{approvalAmount}} dhidi ya ombi la {{appliedAmount}}. Je, unataka kuendelea?",
            moveToPayment: "Hamisha dai {{claimNo}} kwa malipo?",
            visit: "Ziara",
            outstanding: "Inasubiri",
            os: "OS",
            payee: "Mlipa",
            details: "Maelezo",
            correspondence: "Mawasiliano",
            comments: "Maoni",
            source: "Chanzo",
            narration: "Maelezo",
            contribution: "Mchango",
            contributions: "Michango",
            unspecified: "Haijabainishwa",
            year: "Mwaka",
            period: "Kipindi",
            mode: "Hali",
            documentNo: "Nambari ya hati",
            amount: "Kiasi",
            summary: "Muhtasari",
            accountsReceivables: "Mapato ya Akaunti",
            accountsReceivablesDesc: "Karibu kwenye Akaunti Zinazopokea! Boresha udhibiti wako wa mtiririko wa pesa ukitumia vipengele kama vile ankara ya msimbo wa QR, kulinganisha malipo na usaidizi wa sarafu nyingi. Rahisisha mikusanyiko na usalie juu ya mambo unayopokea!",
            newReceipt: "Risiti Mpya",
            accountsPayables: "Malipo ya Akaunti",
            accountsPayablesDesc: "Karibu kwenye Malipo ya Akaunti! Rahisisha malipo yako kwa kutumia vipengele kama vile ujumuishaji wa msimbo wa QR, kulinganisha ankara na usaidizi wa sarafu nyingi. Rahisisha utendakazi wako na upate udhibiti bora wa fedha zako!",
            newPayment: "Malipo Mapya",
            help: "Msaada",
            howItWorks: "Jinsi Inavyofanya",
            how: "Jinsi",
            email: "Barua pepe",
            emailToClient: "Barua pepe kwa mteja",
            download: "Pakua",
            document: "Hati",
            documents: "Nyaraka",
            clientsAndPatners: "Wateja na Washirika",
            clientsAndPatnersDesc: "Anza kujenga msingi wa mteja wako na washirika wa biashara na ufuatilie maelezo yao yote katika sehemu moja. Ongeza mteja wako wa kwanza ili kuanza.",
            reset: "Weka Upya",
            voidApproval: "Batili Idhini",
            progress: "Maendeleo",
            riskNoteNo: "Nambari ya Noti ya Hatari",
            policyNo: "Nambari ya Sera",
            policy: "Sera",
            carrier: "Mtoa Huduma",
            intermediary: "Mpatanishi",
            insured: "Aliyehakikishwa",
            phone: "Simu",
            type: "Aina",
            admin: "Admin",
            newProduct: "Bidhaa Mpya",
            newPolicy: "Sera Mpya",
            previewDocument: "Hakiki Hati",
            beneficiaries: "Wafaidika",
            viewReserves: "Tazama Akiba",
            movement: "Harakati",
            previousAmount: "Kiasi cha Awali",
            currentAmount: "Kiasi cha Sasa",
            doneBy: "Imefanywa Na",
            when: "Lini",
            direction: "Mwelekeo",
            injuries: "Majeraha",
            addInjuredPerson: "Ongeza Mtu Aliyejeruhiwa",
            sumInsured: "Jumla ya Bima",
            billedPremium: "Gharama ya Bima",
            premium: "Bima",
            paidPremium: "Bima Iliyolipwa",
            osPremium: "Bima Isiyolipwa",
            claimAmount: "Kiasi cha Madai",
            paid: "Imelipwa",
            addReserve: "Ongeza Akiba",
            description: "Maelezo",
            addDefaults: "Ongeza Chaguomsingi",
            pick: "Chagua",
            conditionsAndClauses: "Masharti na Vifungu",
            referenceNo: "Nambari ya Rejea",
            reference: "Rejea",
            text: "Maandishi",
            product: "Bidhaa",
            transaction: "Muamala",
            issuingBranch: "Tawi la Toleo",
            underwriter: "Mdhamini",
            riskAndCoverage: "Hatari na Ulinzi",
            premiumInstallments: "Malipo ya Bima kwa Awamu",
            wordings: "Maneno",
            excessAndDeductibles: "Ziada na Makato",
            value: "Thamani",
            valueType: "Aina ya Thamani",
            riskNote: "Dokezo la Hatari",
            bizUnit: "Kitengo",
            policyOwner: "Mmiliki wa Sera",
            policyInformation: "Taarifa za Sera",
            matchedRecords: "Rekodi Zilizounganishwa",
            docAmount: "Kiasi cha DOC",
            benefits: "Manufaa",
            add: "Ongeza",
            claimDetails: "Maelezo ya Madai",
            stage: "Hatua",
            importantDates: "Tarehe Muhimu",
            intimation: "Taarifa",
            coverFrom: "Bima Kutoka",
            coverTo: "Bima Hadi",
            lossDate: "Tarehe ya Hasara",
            insuredLife: "Maisha Yaliyohakikishwa",
            jointInsuredLife: "Maisha Yaliyohakikishwa Pamoja",
            riskItem: "Kipengele cha Hatari",
            catg: "Kategoria",
            dateOfBirth: "Tarehe ya Kuzaliwa",
            ageNextBirthday: "Umri wa Siku ya Kuzaliwa Ijayo",
            smoke: "Uvutaji",
            taxNumber: "Nambari ya Kodi",
            code: "Msimbo",
            name: "Jina",
            basicInformation: "Taarifa za Msingi",
            closeAccount: "Funga Akaunti",
            reactivate: "Anzisha Tena",
            underReview: "Inachunguzwa",
            form: "Fomu",
            surname: "Jina la Ukoo",
            personalInformation: "Taarifa Binafsi",
            otherNames: "Majina Mengine",
            idNo: "Kitambulisho",
            gender: "Jinsia",
            dob: "Tarehe ya Kuzaliwa",
            disabledPerson: "Mtu Mwenye Ulemavu",
            employment: "Ajira",
            flag: "Bendera",
            monthlyIncome: "Mapato ya Kila Mwezi",
            institution: "Taasis",
            occupation: "Kazi",
            debit: "Denki",
            credit: "Mikopo",
            affiliations: "Uhusiano",
            household: "Kaya",
            others: "Wengine",
            totalHouseholdIncome: "Jumla ya Mapato ya Kaya",
            accountManagers: "Wasimamizi wa Akaunti",
            manager: "Msimamizi",
            controlLedgers: "Vitabu vya Udhibiti",
            ledgers: "Vitabu vya Kumbukumbu",
            types: "Aina",
            expectedPremium: "Bima Inayotarajiwa",
            endorsementInstructions: "Maelekezo ya Kiambatisho",
            endorsements: "Marekebisho",
            applicableClasses: "Dara Zinazotumika",
            conditions: "Masharti",
            deductiblesExcess: "Makato na Ziada",
            printSection: "Sehemu ya Kuchapisha",
            commissionCode: "Msimbo wa Tume",
            commCode: "Msimbo wa Tume",
            taxCode: "Msimbo wa Kodi",
            enabled: "Imewezeshwa",
            onetime: "Mara Moja",
            motor: "Magari",
            cashAndCarry: "Lipa & Chukua",
            ends: "Inaisha",
            periodType: "Aina ya Kipindi",
            taccount: "T-Account",
            mainLedger: "Main Ledger",
            mainLedgers: "Main Ledgers",
            subLedger: "Sub Ledger",
            subLedgers: "Sub Ledgers",
            cover: "Cover",
            covers: "Covers",
            charge: "Charge",
            charges: "Charges",
            subClass: "Sub Class",
            addLevel: "Add Level",
            entity: "Entity",
            amountCannotBeZero: "Amount cannot be zero",
            drcrFlag: "DrCr Flag",
        }
    },
    fr: {
        translation: {

            appName: "bima essentials.",
            appTagLineA: "Streamlining Insurance",
            appTagLineB: "From end to end!",
            appTagLineDesc: "A powerful solution designed to optimize insurance operations, from underwriting to claims management. Enhance efficiency, reduce risk, and deliver seamless customer experiences with our all-in-one platform.",
            welcomeMessage: "Bonjour {{param1}}, Bienvenue to {{param2}}!",
            login: "Connexion",
            username: "Nom d'utilisateur",
            password: "Mot de passe",
            forgotPassword: "Mot de passe oublié?",
            selectLanguage: "Langue",
            reports: "Rapports",
            report: "Rapport",
            preview: "Aperçu",
            home: "Accueil",
            claims: "Réclamations",
            claim: "Réclamation",
            payment: "Paiement",
            payments: "Paiements",
            receipt: "Reçu",
            receipts: "Reçus",
            everything: "Tout",
            entities: "Entités",
            policies: "Polices",
            vehicles: "Véhicules",
            search: "Rechercher",
            oneNation: "Une Nation",
            oneFuture: "Un Avenir",
            oneHealth: "Une Santé",
            patients: "Patients",
            patient: "Patient",
            refresh: "Rafraîchir",
            newClaim: "Nouvelle réclamation",
            close: "Fermer",
            save: "Enregistrer",
            status: "Statut",
            date: "Date",
            claimNo: "N° de réclamation",
            additionalInformation: "Informations supplémentaires",
            selectedServices: "Services sélectionnés",
            availableServices: "Services disponibles",
            requested: "Demandé",
            approved: "Approuvé",
            attachments: "Pièces jointes",
            attachment: "Pièce jointe",
            priority: "Priorité",
            yourRef: "Votre Réf",
            remarks: "Remarques",
            logout: "Déconnexion",
            roleName: "Administrateur",
            core: "Noyau",
            parameters: "Paramètres",
            gettingStarted: "Commencer",
            company: "Entreprise",
            controls: "Contrôles",
            packages: "Forfaits",
            users: "Utilisateurs",
            profile: "Profil",
            locations: "Lieux",
            files: "Fichiers",
            numberGen: "Génération de numéros",
            finance: "Finance",
            calendars: "Calendriers",
            currencies: "Devises",
            banks: "Banques",
            bankAccounts: "Comptes bancaires",
            integration: "Intégration",
            coa: "Plan comptable",
            statement: "Relevé",
            balances: "Soldes",
            category: "Catégorie",
            underwriting: "Souscription",
            classes: "Classes",
            products: "Produits",
            templates: "Modèles",
            riskNotes: "Notes de risque",
            renewals: "Renouvellements",
            register: "Registre",
            mortality: "Mortalité",
            medicalTests: "Tests médicaux",
            defaultRates: "Taux par défaut",
            claimBox: "Boîte à réclamations",
            payables: "Créditeurs",
            receivables: "Débiteurs",
            setup: "Configuration",
            transactions: "Transactions",
            medicalRequests: "Demandes médicales",
            box: "Boîte",
            poweringHealthcare: "Alimenter la santé pour une nation",
            accessEfficiency: "Efficacité, accès et meilleurs résultats.",
            clientsAndPartners: "Clients & Partenaires",
            clientsAndPartnersDesc: "Commencez à construire votre base de clients et partenaires et suivez tous leurs détails en un seul endroit. Ajoutez votre premier client pour commencer.",
            symptomsDiagnosis: "Symptômes & Diagnostic",
            note: "Note",
            notes: "Notes",
            male: "Homme",
            female: "Femme",
            other: "Autre",
            symptoms: "Symptômes",
            diagnosis: "Diagnostic",
            service: "Service",
            applied: "Appliqué",
            limit: "Limite",
            qty: "Quantité",
            action: "Action",
            claimApproval: "Vous approuvez un total de {{currency}} {{approvalAmount}} contre une demande de {{appliedAmount}}. Voulez-vous continuer?",
            moveToPayment: "Déplacer la réclamation {{claimNo}} vers le paiement?",
            visit: "Visite",
            outstanding: "En attente",
            os: "OS",
            payee: "Bénéficiaire",
            details: "Détails",
            correspondence: "Correspondance",
            comments: "Commentaires",
            source: "Source",
            narration: "Narration",
            contribution: "Contribution",
            contributions: "Cotisations",
            unspecified: "Indéterminé",
            year: "Année",
            period: "Période",
            mode: "Mode",
            documentNo: "Numéro de doc",
            amount: "Montant",
            summary: "Résumé",
            accountsReceivables: "Comptes débiteurs",
            accountsReceivablesDesc: "Bienvenue dans la comptabilité clients ! Optimisez votre gestion de trésorerie grâce à des fonctionnalités telles que la facturation par code QR, la mise en correspondance des paiements et la prise en charge multidevises. Simplifiez vos encaissements et maîtrisez vos créances !",
            newReceipt: "Nouveau reçu",
            accountsPayables: "Comptes créditeurs",
            accountsPayablesDesc: "Bienvenue dans la comptabilité fournisseurs ! Simplifiez vos paiements grâce à des fonctionnalités comme l'intégration de codes QR, le rapprochement de factures et la prise en charge multidevises. Simplifiez vos flux de travail et maîtrisez mieux vos finances !",
            newPayment: "Nouveau paiement",
            help: "Aide",
            howItWorks: "Comment ça marche",
            how: "Comment",
            email: "E-mail",
            emailToClient: "E-mail au client",
            download: "Télécharger",
            document: "Document",
            documents: "Documents",
            clientsAndPatners: "Clients et partenaires",
            clientsAndPatnersDesc: "Commencez à développer votre base de clients et de partenaires commerciaux et suivez toutes leurs informations en un seul endroit. Ajoutez votre premier client pour commencer.",
            reset: "Réinitialiser",
            voidApproval: "Annuler l'approbation",
            progress: "Progrès",
            riskNoteNo: "Numéro de note de risque",
            policyNo: "Numéro de police",
            policy: "Police",
            carrier: "Transporteur",
            intermediary: "Intermédiaire",
            insured: "Assuré",
            phone: "Téléphone",
            type: "Type",
            admin: "Admin",
            newProduct: "Nouveau Produit",
            newPolicy: "Nouvelle Police",
            previewDocument: "Aperçu du Document",
            beneficiaries: "Bénéficiaires",
            viewReserves: "Voir les Réserves",
            movement: "Mouvement",
            previousAmount: "Montant Précédent",
            currentAmount: "Montant Actuel",
            doneBy: "Effectué Par",
            when: "Quand",
            direction: "Direction",
            injuries: "Blessures",
            addInjuredPerson: "Ajouter une Personne Blessée",
            sumInsured: "Somme Assurée",
            billedPremium: "Prime Facturée",
            premium: "Prime",
            paidPremium: "Prime Payée",
            osPremium: "Prime Impayée",
            claimAmount: "Montant de la Réclamation",
            paid: "Payé",
            addReserve: "Ajouter une Réserve",
            description: "Description",
            addDefaults: "Ajouter des Valeurs Par Défaut",
            pick: "Choisir",
            conditionsAndClauses: "Conditions et Clauses",
            referenceNo: "Numéro de Référence",
            reference: "Référence",
            text: "Texte",
            product: "Produit",
            transaction: "Transaction",
            issuingBranch: "Agence Émettrice",
            underwriter: "Souscripteur",
            riskAndCoverage: "Risque et Couverture",
            premiumInstallments: "Versements de Prime",
            wordings: "Libellés",
            excessAndDeductibles: "Franchises et Déductions",
            value: "Valeur",
            valueType: "Type de Valeur",
            riskNote: "Note de Risque",
            bizUnit: "Unité",
            policyOwner: "Propriétaire de la Police",
            policyInformation: "Informations sur la Police",
            matchedRecords: "Dossiers Correspondants",
            docAmount: "Montant DOC",
            benefits: "Avantages",
            add: "Ajouter",
            claimDetails: "Détails de la Réclamation",
            stage: "Étape",
            importantDates: "Dates Importantes",
            intimation: "Notification",
            coverFrom: "Couverture à Partir de",
            coverTo: "Couverture Jusqu'à",
            lossDate: "Date de Perte",
            insuredLife: "Vie Assurée",
            jointInsuredLife: "Vie Assurée Conjointe",
            riskItem: "Élément de Risque",
            catg: "Catégorie",
            dateOfBirth: "Date de Naissance",
            ageNextBirthday: "Âge au Prochain Anniversaire",
            smoke: "Fume",
            taxNumber: "Numéro Fiscal",
            code: "Code",
            name: "Nom",
            basicInformation: "Informations de Base",
            closeAccount: "Fermer le Compte",
            reactivate: "Réactiver",
            underReview: "En Cours d'Examen",
            form: "Formulaire",
            surname: "Nom de Famille",
            personalInformation: "Informations Personnelles",
            otherNames: "Autres Noms",
            idNo: "Numéro d'Identité",
            gender: "Genre",
            dob: "Date de Naissance",
            disabledPerson: "Personne Handicapée",
            employment: "Emploi",
            flag: "Drapeau",
            monthlyIncome: "Revenu Mensuel",
            institution: "Institution",
            occupation: "Occupation",
            debit: "Débit",
            credit: "Crédit",
            affiliations: "Affiliations",
            household: "Foyer",
            others: "Autres",
            totalHouseholdIncome: "Revenu Total du Foyer",
            accountManagers: "Gestionnaires de Comptes",
            manager: "Gestionnaire",
            controlLedgers: "Grand-Livres de Contrôle",
            ledgers: "Grand-Livres",
            types: "Types",
            expectedPremium: "Prime Attendue",
            endorsementInstructions: "Instructions d'Avenant",
            endorsements: "Avenants",
            applicableClasses: "Classes Applicables",
            conditions: "Conditions",
            deductiblesExcess: "Franchises et Excès",
            printSection: "Section d'Impression",
            commissionCode: "Code de Commission",
            commCode: "Code de Comm",
            taxCode: "Code Fiscal",
            enabled: "Activé",
            onetime: "Unique",
            motor: "Automobile",
            cashAndCarry: "Paiement Comptant",
            ends: "Se Termine",
            periodType: "Type de Période",
            taccount: "T-Account",
            mainLedger: "Main Ledger",
            mainLedgers: "Main Ledgers",
            subLedger: "Sub Ledger",
            subLedgers: "Sub Ledgers",
            cover: "Cover",
            covers: "Covers",
            charge: "Charge",
            charges: "Charges",
            subClass: "Sub Class",
            addLevel: "Add Level",
        }
    },
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: "en",
        lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;